const mediaItems = [
  {
    title: '本周热播：悬疑剧场',
    desc: '烧脑推理·高能反转',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20with%20mysterious%20dramatic%20lighting%2C%20deep%20amber%20and%20crimson%20tones%2C%20dark%20silhouette%20composition%2C%20elegant%20suspense%20thriller%20aesthetic%2C%20rich%20textured%20shadows%20with%20golden%20highlights%2C%20sophisticated%20movie%20poster%20design&width=600&height=800&seq=media-mystery&orientation=portrait',
    badge: '热播中',
  },
  {
    title: '经典重温：高分神作',
    desc: '豆瓣9.0+ · 百看不厌',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20classic%20film%20poster%20aesthetic%20with%20warm%20vintage%20golden%20lighting%2C%20rich%20amber%20and%20sepia%20tones%2C%20sophisticated%20timeless%20cinema%20composition%2C%20dark%20velvet%20background%20with%20soft%20glow%2C%20premium%20movie%20art%20style&width=600&height=800&seq=media-classic&orientation=portrait',
    badge: '经典',
  },
  {
    title: '新片速递：科幻巨献',
    desc: '视觉盛宴·脑洞大开',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cinematic%20film%20poster%20with%20deep%20space%20and%20warm%20golden%20nebula%20lighting%2C%20dramatic%20amber%20glow%20against%20dark%20cosmic%20background%2C%20elegant%20sci-fi%20movie%20aesthetic%2C%20sophisticated%20composition%2C%20rich%20contrast&width=600&height=800&seq=media-scifi&orientation=portrait',
    badge: '新上线',
  },
  {
    title: '综艺精选：爆笑合集',
    desc: '欢乐不停·笑到肚子疼',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20cinematic%20stage%20poster%20with%20warm%20golden%20spotlights%20on%20dark%20background%2C%20elegant%20entertainment%20show%20aesthetic%2C%20dramatic%20amber%20lighting%20effects%2C%20sophisticated%20variety%20program%20visual%2C%20rich%20theater%20atmosphere&width=600&height=800&seq=media-variety&orientation=portrait',
    badge: '热播',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              精选推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              编辑力荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              编辑团队精心挑选，本期不容错过的精彩内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <article key={item.title} className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer">
                <img
                  src={item.image}
                  alt={`成全影院${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-semibold rounded-md whitespace-nowrap">{item.badge}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-base font-semibold text-white mb-1">{item.title}</h3>
                  <p className="text-xs text-white/70">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}